import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Button,
  Typography,
  Container
} from '@mui/material';
import { UserRole } from 'shared/types';

interface InvitationSuccessScreenProps {
  companyName?: string;
  role?: UserRole;
  stringsLabel: string;
  onGoToLogin: () => void;
}

export const InvitationSuccessScreen: React.FC<InvitationSuccessScreenProps> = ({
  companyName,
  role,
  stringsLabel,
  onGoToLogin
}) => {
  return (
    <Container component="main" maxWidth="sm">
      <Box sx={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 3
      }}>
        <Card sx={{
          width: '100%',
          textAlign: 'center',
          p: 4,
          position: 'relative',
          overflow: 'hidden'
        }}>
          <Box
            sx={{
              position: 'absolute',
              top: 10,
              right: 20,
              opacity: 0.08,
              zIndex: 0,
              pointerEvents: 'none',
              display: { xs: 'none', md: 'block' }
            }}
          >
            <img
              src="/safety-logo.png"
              alt=""
              style={{
                width: '100px',
                height: '100px',
                objectFit: 'contain'
              }}
            />
          </Box>

          <CardContent sx={{ position: 'relative', zIndex: 1 }}>
            <Box sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: 'success.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px auto'
            }}>
              <Typography
                variant="h2"
                sx={{
                  color: 'white',
                  fontSize: '3rem'
                }}
              >
                ✓
              </Typography>
            </Box>

            <Typography variant="h4" gutterBottom sx={{ color: 'success.main', mb: 2 }}>
              ¡Registro Exitoso!
            </Typography>

            <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
              Tu cuenta ha sido creada exitosamente usando el código de invitación.
            </Typography>

            {companyName && role && (
              <Box sx={{
                backgroundColor: 'primary.light',
                color: 'primary.contrastText',
                borderRadius: 1,
                p: 2,
                mb: 3
              }}>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {stringsLabel}: {companyName}
                </Typography>
                <Typography variant="body2">
                  Rol asignado: {role}
                </Typography>
              </Box>
            )}

            <Typography variant="body2" sx={{ mb: 4, color: 'text.secondary' }}>
              Ya puede iniciar sesión con sus credenciales.
            </Typography>

            <Button
              variant="contained"
              size="large"
              fullWidth
              onClick={onGoToLogin}
              sx={{ py: 1.5 }}
            >
              Ir a Inicio de Sesión
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};
